export default __webpack_public_path__ + "static/media/0.e9a87367.png";